import React from "react";
import Link from "next/link";
import { MetaWrap, MetaAuthor, MetaCategory, MetaLocation } from "./styled";

const Meta = ({ user }) => {
  if (!user) return <div>Loading...</div>;

  const { slug } = user;
  let href = "/users/[id]";
  let as = `/users/${user.id}`;

  if (slug) {
    href = "/[id]";
    as = `/${slug}`;
  }

  return (
    <MetaWrap>
      By{" "}
      <MetaAuthor>
        <Link href={href} as={as}>
          <a>
            {user.show_business_name ? (
              user.business_name
            ) : (
              <>
                {user.first_name} {user.last_name}
              </>
            )}
          </a>
        </Link>
      </MetaAuthor>
      <MetaCategory>
        <Link href="#">{user.work_place ? user.work_place : ""}</Link>
      </MetaCategory>
      <MetaLocation>
        <Link href="#">{user.location ? user.location : ""}</Link>
      </MetaLocation>
    </MetaWrap>
  );
};

export default Meta;
